<div class="kh-card" [ngClass]="{'selected': isSelected}">
	<img class="kh-card-icon" [src]="iconUrl" *ngIf="showIcon">
	<div class="kh-div-spacer-xs" *ngIf="showIcon"></div>
	<span class="kh-title-md">
		{{text}}
	</span>
</div>
